<div class="form-response-viewer">
	<div class="d-flex justify-content-between align-items-start flex-wrap">
		<div class="fw-bold">
			{{form?.title}}
			<span *ngIf="response?.title"> - {{response?.title}}</span>
		</div>
		<small class="text-muted ms-2 text-nowrap" *ngIf="response?.created">{{response?.created | shortDate:'full'}}</small>
	</div>
	<div *ngIf="sorted_answers.length == 0" class="text-muted fst-italic">Sin respuestas registradas</div>
	<div class="row mt-1" *ngFor="let ai of sorted_answers">
		<div class="col-12 col-md-4 fw-bold">{{ai.question.question}}</div>
		<div class="col-12 col-md-8">{{getAnswerValue(ai)}}</div>
	</div>
</div>
